import * as FileSystem from "@-/com.npmjs.expo-file-system";
import { useRemoteLogs } from "@-/com.npmjs.rozenite-remote-logs";
import {
  createExpoFileSystemAdapter,
  useFileSystemDevTools,
} from "@-/com.npmjs.rozenite__file-system-plugin";
import { usePerformanceMonitorDevTools } from "@-/com.npmjs.rozenite__performance-monitor-plugin";
import { useTanStackQueryDevTools } from "@-/com.npmjs.rozenite__tanstack-query-plugin";
import type { QueryClient } from "@-/com.npmjs.tanstack__react-query";
import { useState } from "react";
import { isRozeniteNativeDevtoolsAvailable } from "#is-rozenite-native-devtools-available";

export type UseRootLayoutShellDevtoolsArgs = {
  queryClient: QueryClient;
};

/** Installs root-layout Rozenite shell plugins when the FuseBox bridge is present at first mount. */
export function useRootLayoutShellDevtools({ queryClient }: UseRootLayoutShellDevtoolsArgs) {
  const [enabled] = useState(isRozeniteNativeDevtoolsAvailable);

  if (!enabled) {
    return;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- `enabled` is fixed for this mount via useState
  useTanStackQueryDevTools(queryClient);
  // eslint-disable-next-line react-hooks/rules-of-hooks -- see above
  usePerformanceMonitorDevTools();
  // eslint-disable-next-line react-hooks/rules-of-hooks -- see above
  useFileSystemDevTools({ adapter: createExpoFileSystemAdapter(FileSystem) });
  // Metro project root is `apps/haniverse-expo`; Rozenite writes paths on the host relative to that cwd.
  // eslint-disable-next-line react-hooks/rules-of-hooks -- see above
  useRemoteLogs({ autoEnable: true, filePath: "../../.logs/app.log" });
}
